import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from "react-select";

class FormCreate extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            questions: [],
            isLoaded: true
        }
    }

    componentDidMount = () => {
        this.loadData();
    }

    loadData = () => {
        fetch(`/formatos/get_questions_formats/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    questions: data.data,
                    isLoaded: false
                });
            });
    }

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        const isReady = this.props.format_subform_targets.length >= 1 && this.props.there_is_format_subform_targets && this.props.format_subform_sources.length >= 1 && this.props.there_is_format_subform_sources;
        const canSave = isReady && this.props.formValues.format_subform_source_id != "" && this.props.formValues.format_subform_target_id != "";

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    <div style={{ padding: '8px 0' }}>
                        <p style={{ fontSize: 13, color: '#666', margin: '0 0 16px 0' }}>
                            Configura la duplicacion automatica de registros desde un subformulario de otro formato hacia un subformulario de este formato.
                        </p>

                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <input type="hidden" name="format_source_id" value={this.props.selectedOption.format_source_id} />
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Formato fuente</label>
                                <Select
                                    onChange={this.props.handleChangeAutocomplete}
                                    options={this.props.formatos}
                                    autoFocus={false}
                                    className={`link-form ${!this.props.errorValues && this.props.formValues.format_source_id == "" ? "error-class" : ""}`}
                                    value={this.props.selectedOption}
                                    placeholder="Seleccione un formato..."
                                />
                                <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Formato del cual se copiaran los items</span>
                            </div>

                            <div style={{ flex: 1 }}>
                                <input type="hidden" name="format_subform_source_id" value={this.props.selectedOptionFormatSubFormSource.format_subform_source_id} />
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Subformulario fuente</label>
                                <Select
                                    onChange={this.props.handleChangeAutocompleteFormatSubFormSource}
                                    options={this.props.format_subform_sources}
                                    autoFocus={false}
                                    isDisabled={this.props.format_subform_sources.length === 0}
                                    className={`link-form ${!this.props.errorValues && this.props.formValues.format_subform_source_id == "" ? "error-class" : ""}`}
                                    value={this.props.selectedOptionFormatSubFormSource}
                                    placeholder={this.props.format_subform_sources.length === 0 ? "Seleccione un formato fuente primero" : "Seleccione un subformulario..."}
                                />
                                <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Subformulario del formato fuente de donde se copiaran los registros</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <input type="hidden" name="question_asociation_id" value={this.props.selectedOptionQuestion.question_asociation_id} />
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Pregunta de vinculacion</label>
                                <Select
                                    onChange={this.props.handleChangeAutocompleteQuestions}
                                    options={this.state.questions}
                                    autoFocus={false}
                                    className={`link-form ${!this.props.errorValues && this.props.formValues.question_asociation_id == "" ? "error-class" : ""}`}
                                    value={this.props.selectedOptionQuestion}
                                    placeholder="Seleccione una pregunta..."
                                />
                                <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Pregunta tipo formato que conecta con el formato fuente</span>
                            </div>

                            <div style={{ flex: 1 }}>
                                <input type="hidden" name="format_subform_target_id" value={this.props.selectedOptionFormatSubFormTarget.format_subform_target_id} />
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Subformulario destino</label>
                                <Select
                                    onChange={this.props.handleChangeAutocompleteFormatSubFormTarget}
                                    options={this.props.format_subform_targets}
                                    autoFocus={false}
                                    isDisabled={this.props.format_subform_targets.length === 0}
                                    className={`link-form ${!this.props.errorValues && this.props.formValues.format_subform_target_id == "" ? "error-class" : ""}`}
                                    value={this.props.selectedOptionFormatSubFormTarget}
                                    placeholder={this.props.format_subform_targets.length === 0 ? "No hay subformularios disponibles" : "Seleccione un subformulario..."}
                                />
                                <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Subformulario de este formato donde se crearan los registros duplicados</span>
                            </div>
                        </div>

                        <div className={`alert alert-${isReady ? "success" : "danger"} p-2`} role="alert" style={{ fontSize: 13 }}>
                            {isReady ? (
                                <div className='text-center'>
                                    <i className="fas fa-check-circle mr-1" />
                                    <b>Configuracion lista. {this.props.modeEdit ? "Actualiza" : "Completa"} los campos y guarda.</b>
                                </div>
                            ) : (
                                <div>
                                    <b>Para continuar se deben completar estas condiciones:</b>
                                    <ul style={{ marginBottom: 0, marginTop: 4 }}>
                                        <li className={this.props.format_subform_targets.length >= 1 && this.props.there_is_format_subform_targets ? "color-password" : "color-falsePassword"}>
                                            Este formato debe tener al menos un subformulario
                                        </li>
                                        <li className={this.props.format_subform_sources.length >= 1 && this.props.there_is_format_subform_sources ? "color-password" : "color-falsePassword"}>
                                            El formato fuente debe tener al menos un subformulario
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => this.props.toggle()}>
                                Cancelar
                            </button>
                            {canSave && (
                                <button className="btn btn-info btn-sm" onClick={() => this.props.submitForm()}>
                                    {this.props.nameBnt}
                                </button>
                            )}
                        </div>
                    </div>
                </form>
            </React.Fragment>
        );
    }
}

export default FormCreate;